module.exports = __webpack_public_path__ + "static/media/7-appetite-for-apathy.17a4e37.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/7-appetite-for-apathy.mp3
// module id = wR73
// module chunks = 0